import React from "react";
import { Instagram, Mail } from "lucide-react";
import { INSTAGRAM_URL, CONTACT_EMAIL } from "../assets";

export default function Footer({ t }) {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="footer" className="relative bg-ink border-t border-line">
      <div className="px-6 md:px-12 lg:px-20 py-12 md:py-16">
        <div className="grid md:grid-cols-12 gap-10 md:gap-16">
          <div className="md:col-span-6">
            <div className="flex items-center gap-5">
              <img
                data-testid="footer-logo"
                src="/fl-logo.png"
                alt="Fight-Lens"
                loading="lazy"
                className="h-14 w-14 md:h-16 md:w-16 rounded-full"
              />
              <p translate="no" className="notranslate font-display text-5xl md:text-7xl tracking-wider text-bone">NONO</p>
            </div>
            <p className="mt-3 text-[11px] tracking-[0.4em] uppercase text-ash">
              <span translate="no" className="notranslate">Alexis Lecoeuvre</span> — {t.footer.built}
            </p>
          </div>
          <div className="md:col-span-3">
            <p className="text-[10px] tracking-[0.4em] uppercase text-ash mb-3">Contact</p>
            <a
              href={`mailto:${CONTACT_EMAIL}`}
              data-testid="footer-email"
              className="link-underline inline-flex items-center gap-2 text-bone hover:text-leaf text-sm py-2"
            >
              <Mail size={14} strokeWidth={1.5} /> {CONTACT_EMAIL}
            </a>
          </div>
          <div className="md:col-span-3">
            <p className="text-[10px] tracking-[0.4em] uppercase text-ash mb-3">Social</p>
            <a
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram"
              className="link-underline inline-flex items-center gap-2 text-bone hover:text-leaf text-sm py-2"
            >
              <Instagram size={14} strokeWidth={1.5} /> <span translate="no" className="notranslate">@nono.lcv</span>
            </a>
          </div>
        </div>

        {/* Legal notice */}
        <div data-testid="footer-legal" className="mt-12 pt-8 border-t border-line">
          <p className="text-[10px] tracking-[0.4em] uppercase text-ash mb-2">{t.footer.legalTitle}</p>
          <p className="text-[11px] tracking-[0.14em] text-ash/90 leading-relaxed">
            <span translate="no" className="notranslate">Fight-Lens</span> — Alexis Lecoeuvre ·{" "}
            <span data-testid="footer-siret" className="text-bone/80">{t.footer.legalSiret}</span> · {t.footer.legalRegistered}
          </p>
        </div>

        <div className="mt-8 pt-8 border-t border-line flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <p className="text-[10px] tracking-[0.4em] uppercase text-ash">© {year} <span translate="no" className="notranslate">Nono.lcv</span> — {t.footer.rights}</p>
          <p className="text-[10px] tracking-[0.4em] uppercase text-ash/70">{t.footer.tagline}</p>
        </div>
      </div>
    </footer>
  );
}
